"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _auth = require("@/api/auth");
var _auth2 = require("@/utils/auth");
var _vuexModuleDecorators = require("vuex-module-decorators");
var UserStore = /*#__PURE__*/function (_VuexModule) {
  function UserStore() {
    var _this;
    (0, _classCallCheck2.default)(this, UserStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, UserStore, [].concat(args));
    (0, _defineProperty2.default)(_this, "token", (0, _auth2.getToken)());
    (0, _defineProperty2.default)(_this, "info", {});
    return _this;
  }
  (0, _inherits2.default)(UserStore, _VuexModule);
  return (0, _createClass2.default)(UserStore, [{
    key: "SET_TOKEN",
    value: function SET_TOKEN(token) {
      this.token = token;
    }
  }, {
    key: "SET_INFO",
    value: function SET_INFO(info) {
      this.info = info;
    }
  }, {
    key: "login",
    value: function () {
      var _login = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(userInfo) {
        var response, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _auth.authApi.login(userInfo);
            case 2:
              response = _context.sent;
              data = response.data;
              (0, _auth2.setToken)(data.token);
              this.context.commit('SET_TOKEN', data.token);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function login(_x) {
        return _login.apply(this, arguments);
      }
      return login;
    }() // get user info
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _auth.authApi.getInfo();
            case 2:
              res = _context2.sent;
              data = res.data;
              _context2.next = 6;
              return this.context.commit('SET_INFO', data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }() // user logout
  }, {
    key: "logout",
    value: function logout() {
      this.context.commit("SET_TOKEN", "");
      (0, _auth2.removeToken)();
    }
    // remove token
  }, {
    key: "resetToken",
    value: function resetToken() {
      this.context.commit("SET_TOKEN", "");
      (0, _auth2.removeToken)();
    }
  }]);
}(_vuexModuleDecorators.VuexModule);
(0, _tslib.__decorate)([_vuexModuleDecorators.Mutation], UserStore.prototype, "SET_TOKEN", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Mutation], UserStore.prototype, "SET_INFO", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], UserStore.prototype, "login", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], UserStore.prototype, "getInfo", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], UserStore.prototype, "logout", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], UserStore.prototype, "resetToken", null);
UserStore = (0, _tslib.__decorate)([(0, _vuexModuleDecorators.Module)({
  name: 'user'
})], UserStore);
var _default = exports.default = UserStore;